import { render, staticRenderFns } from "./ve-player.vue?vue&type=template&id=4736b45f"
import script from "./ve-player.vue?vue&type=script&lang=js"
export * from "./ve-player.vue?vue&type=script&lang=js"
import style0 from "./ve-player.vue?vue&type=style&index=0&id=4736b45f&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4736b45f')) {
      api.createRecord('4736b45f', component.options)
    } else {
      api.reload('4736b45f', component.options)
    }
    module.hot.accept("./ve-player.vue?vue&type=template&id=4736b45f", function () {
      api.rerender('4736b45f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ve-player.vue"
export default component.exports